
import { LoaderIcon } from "lucide-react";

const PollLoadingState = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <LoaderIcon className="h-12 w-12 text-nation-blue animate-spin" />
      <h2 className="text-xl font-medium mt-4">Loading poll details...</h2>
    </div>
  );
};

export default PollLoadingState;
